import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=b9aef6d2&"
import script from "./SalesOrder.vue?vue&type=script&lang=js&"
export * from "./SalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports